// Generated by scripts/generate-app-version.mjs.
export const APP_RELEASE = {
  "version": "1.0.0",
  "buildId": "20261105T091320203Z",
  "builtAt": "2026-11-05T09:13:20.203Z"
} as const;
